import {createReducer} from '@reduxjs/toolkit';
import {add, remove, set} from '../actions/selections.js';
import {enableCompare} from '../actions/settings.js';
import {reset as resetWizard} from '../actions/wizard.js';

const defaultState = [];
export default createReducer(defaultState, builder => {
  builder.addCase(set, (state, {payload}) => payload);
  builder.addCase(add, (state, {payload}) => [...state, payload]);
  builder.addCase(remove, (state, {payload}) =>
    state.filter(selection => selection.id !== payload.id),
  );
  builder.addCase(resetWizard, () => defaultState);
  builder.addCase(enableCompare, state => {
    if (state.length <= 2) {
      return state;
    }

    return [state[0], state[state.length - 1]];
  });
});
